export default "__VITE_ASSET__D2Lqb0wo__"